import React from "react";
import { NodeProps } from "reaflow";
import {
  findNodeComponentByType,
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseEdgeDataType,
} from "../WorkflowUtils";

export type NodeRouterPropsType = NodeProps & {
  isDisabled?: boolean;
  allNodes: BaseNodeDataType[];
  allEdges: BaseEdgeDataType[];
  selectedNode?: BaseNodeDataType | null;
  onNodeClick(node: BaseNodeDataType): void;
  onDeleteNode(node: BaseNodeDataType): void;
  onGroupAdd(node: BaseNodeDataType): void;
  onPortDragEnd(fromNodeId: string, toNodeId?: string): void;
};

/**
 * Node router.
 *
 * Acts as a router between node layouts, by rendering a different node layout, depending on the node "data.type" property.
 */
const NodeRouter: React.FunctionComponent<NodeRouterPropsType> = (props) => {
  const nodeType = props?.properties?.data?.type;
  const node: BaseNodeDataType = props.allNodes.find(
    (node: BaseNodeDataType) => node.id === props.properties.id
  ) as BaseNodeDataType;

  const { width, height, ...nodeProps } = props;

  // If the node is not defined then we don't render the node component because it'll crash
  // XXX It can happen sometimes when removing nodes that are being displayed,
  //  the node itself still exist in the Canvas, but doesn't exist anymore in the "nodesState".

  if (typeof node === "undefined") {
    return null;
  }

  if (!nodeType) {
    try {
      console.error(
        `Node with nodeType="${nodeType}" couldn't be rendered. Props: ${JSON.stringify(props, null, 2)}`
      );
    } catch (e) {
      console.error(
        `Node with nodeType="${nodeType}" couldn't be rendered. Props cannot be stringified.`
      );
    }
    return null;
  }
  // Will render a specialized node (e.g: StartNode, etc.)
  const NodeComponent: BaseNodeComponentType =
    findNodeComponentByType(nodeType);
  return (
    <NodeComponent {...nodeProps} width={width} height={height} node={node} />
  );
};

export default NodeRouter;
